import React from 'react';
import BreadCrumbs from '../../components/breadCrumbs';
import {useRouter} from '../../../../../@casino/useRouter';
import {useDispatch, useSelector} from 'react-redux';
import {setGetRezyme} from '../../store/thunk/setGetRezyme';
import TableCasino from '../../../../../@casino/ui/table';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    p20: {
        padding: 20, 
    }
}))

const ReportGameGamer = () => {
    const router = useRouter();
    const id = router.match.params.id;
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetRezyme({
            id,
            page: 1,
            rowsPerPage: 10
        }))
    }, [id])

    const rezymeArr = useSelector(state => state.users.rezyme);
    const rows = React.useMemo(() => getRows(rezymeArr.data), [rezymeArr]);   
    
    return (
        <div>
            <BreadCrumbs label={id} description='Отчет о событиях'/>
            <div className={classes.p20}>
                <TableCasino 
                        allPage={1}
                        pagination
                        width={1280}
                        perPage={10}
                        columns={columns}
                        rows={rows}
                        changePage={(v) => dispatch(setGetRezyme({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetRezyme({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    /> 
            </div>
        </div>
    )
}

export default ReportGameGamer;